import React from "react";
import { Box, Container, Divider, makeStyles } from "@material-ui/core";
import { Page, FooterSmall, OtherServices, Typography } from "@packages/ui";
import { useSelector, useDispatch } from "react-redux";
import getBrandFromUrl from "../../utils/getBrandFromUrl";
import * as constants from "../../utils/constants";
import VirContactForm from "../../components/VirContactForm";
import ContactSuccess from "src/components/VirContactForm/ContactSuccess";
import getServiceFromUrl from "../../utils/getServiceFromUrl";
import getCountryFromURL from "src/utils/getCountryFromUrl";
import HertzTick from "src/assets/images/hertz_tick.png";
import DollarTick from "src/assets/images/dollar_tick.png";
import ThriftyTick from "src/assets/images/thrifty_tick.png";
import AceTick from "src/assets/images/ace_tick.png";
import _ from "lodash";
import getStageFromUrl from "src/utils/getStageFromUrl";



const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
  },
  tile: {
    width: "100%",
  },
  container: {
    backgroundColor: "white",
    paddingTop: 35,
    paddingBottom: 20,
    borderRadius: 5,
    [theme.breakpoints.up("xs")]: { border: "none", borderRadius: 0 },
    [theme.breakpoints.up("sm")]: {
      border: "solid 1px lightgrey",
      borderBottom: `solid 5px ${theme.palette.primary.main}`,
      borderRadius: 5,
    },
  }
}));

const ContactUs = () => {
  const classes = useStyles();
  const brand = getBrandFromUrl();
  const stage = getStageFromUrl();
  const brandStyles = {
    ace: {
      logo: "/assets/images/ace_logo.jpg",
      altLogo: "Ace",
      checkmark: AceTick,
      color:"#00386b",
      textColor: "white",
      titleFontFamily: "Roboto",
      textFontFamily: "Roboto",
      mjpURL: constants.MJP_LOGIN_URL_LINKS[stage].MJP_LOGIN_URL_ACE_AU
    },
    dollar: {
      logo: "/assets/images/dollar_logo.png",
      altLogo: "Dollar",
      checkmark: DollarTick,
      color:"#c8102e",
      textColor: "white",
      titleFontFamily: "ITC Avant Garde",
      textFontFamily: "ITC Avant Garde",
      mjpURL: constants.MJP_LOGIN_URL_LINKS[stage].MJP_LOGIN_URL_DOLLAR_AU
    },
    hertz: {
      logo: "/assets/images/hertz_logo.png",
      altLogo: "Hertz",
      checkmark: HertzTick,
      color:"#ffcc00",
      textColor: "black",
      titleFontFamily: "Ride",
      textFontFamily: "Ride",
      mjpURL: constants.MJP_LOGIN_URL_LINKS[stage].MJP_LOGIN_URL_HERTZ_AU
    },
    thrifty: {
      logo: "/assets/images/thrifty_logo.png",
      altLogo: "Thrifty",
      checkmark: ThriftyTick,
      color:"#007ac3",
      textColor: "white",
      titleFontFamily: "TTRounds",
      textFontFamily: "AvenirNextLTPro",
      mjpURL: constants.MJP_LOGIN_URL_LINKS[stage].MJP_LOGIN_URL_THRIFTY_AU
    }
  };
  const brandStyle = !_.isNil(brandStyles[brand.toLowerCase()]) ? brandStyles[brand.toLowerCase()] : brandStyles.hertz;
  const virSendContact = useSelector((state) => state.vir.virSendContact);

  return !virSendContact.success ? ( 
    <Page
      className={classes.root}
      title="Contact Us"
      style={{ background: "white", textAlign: "center" }}
    >
      <div style={{paddingBottom: "20px", paddingTop: "20px" }}>
        <Typography variant="h2">
            Contact Us
        </Typography>
      </div>
      <Box display="flex" flexDirection="row" justifyContent="center" className={classes.box}>
        <Container maxWidth="sm" className={classes.container}>
          <VirContactForm brand={brand} />
          <Divider style={{ marginTop: 50, marginBottom: 40 }} />
          <FooterSmall brand={brand} />
        </Container>
      </Box>
    </Page>
  ) 
  : ( <ContactSuccess brandStyle={brandStyle} />  ) 
};

export default ContactUs;
